import { connectRouter, routerMiddleware } from "connected-react-router";
import { History } from "history";
import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import { createLogger } from "redux-logger";
import thunk from "redux-thunk";
import { LocalStorage } from "../LocalStorage";
import { ApplicationState, reducers } from "./";

const initialState: ApplicationState = {
  alerts: {
    alerts: [],
  },
  logs: {
    UWG5Nvent: [],
    NuHeat: [],
  },
  uwg5Nvent: {
    thermostats: [],
    loadable: [],
    distributors: [],
    users: [],
  },
  legacy: {
    NuHeat: {
      thermostats: [],
      loadable: [],
    },
  },
  workspace: LocalStorage.getWorkspace(),
};

export default function configureStore(history: History) {
  const middleware = [thunk, routerMiddleware(history)];

  if (process.env.NODE_ENV === "development") {
    const logger = createLogger({
      // ...options, see https://github.com/LogRocket/redux-logger#options
    });
    middleware.push(logger);
  }

  const rootReducer = combineReducers({
    ...reducers,
    router: connectRouter(history),
  });

  const enhancers = [];
  const windowIfDefined =
    typeof window === "undefined" ? null : (window as any);
  if (windowIfDefined && windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__) {
    enhancers.push(windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__());
  }

  return createStore(
    rootReducer,
    initialState,
    compose(applyMiddleware(...middleware), ...enhancers)
  );
}
